export default "https://cdn-static.gokick.com/assets/ec0505d9ec69830080e0139f10eb42000fec6561/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";